<aza-rws-profile-header titleTranslationKey="MY_ORDERS" (closed)="onClosed()"></aza-rws-profile-header>
<aza-rws-pager (offsetChanged)="onPagingOffsetChanged($event)" [pagedResponseSubject]="pagedResponseSubject" [pageSize]="5"></aza-rws-pager>
<div class="profile-orders-list-container">
    <section *ngFor="let order of orders" class="aza-section aza-theme">
        <div class="aza-section-content profile-order">
            <div class="profile-order-id">
                <span translate>ID</span>
                <span>{{order.id}}</span>
            </div>
            <div class="profile-order-reference-number">
                <span translate>REFERENCE_NUMBER</span>:
                <span>{{order.reference_number}}</span>
            </div>
            <div class="profile-order-payment-status">
                <span translate>PAYMENT_STATUS</span>:
                <span>{{order.status}}</span>
            </div>
            <div class="profile-order-amount">
                <span translate>AMOUNT</span>:
                <span>{{order.amount}}</span>
            </div>
            <div class="profile-order-discount">
                <span translate>DISCOUNT</span>:
                <span>{{order.discount}}</span>
            </div>
            <div class="profile-order-subtotal">
                <span translate>SUBTOTAL</span>:
                <span>{{order.subtotal}}</span>
            </div>
        </div>
        <section class="section-divider aza-section aza-theme">
            <div class="aza-section-content"></div>
        </section>
    </section>
</div>
<aza-rws-pager (offsetChanged)="onPagingOffsetChanged($event)" [pagedResponseSubject]="pagedResponseSubject" [pageSize]="5"></aza-rws-pager>
